import Enumerable from "linq";

export class MapTranslator<TObject, TBean> {
  constructor(
    private readonly _pairs: IObjectBeanPair<TObject, TBean>[],
    private readonly _defaultObject: TObject,
    private readonly _defaultBean: TBean) {}

  from(bean: TBean): TObject {
    const pair = Enumerable.from(this._pairs)
      .firstOrDefault(p => p.bean === bean);
    return ((pair === undefined) || (pair === null))
      ? this._defaultObject
      : pair.object;
  }

  to(object: TObject): TBean {
    const pair = Enumerable.from(this._pairs)
      .firstOrDefault(p => p.object === object);
    return ((pair === undefined) || (pair === null))
      ? this._defaultBean
      : pair.bean;
  }
}

export interface IObjectBeanPair<TObject, TBean> {
  object: TObject;
  bean: TBean;
}
